import React from "react";
import PatientsList from "./utils/PatientsList";

const Patients = () => {
  return (
    <PatientsList 
      showOnlyPinned={false}
      pageTitle="My Patients"
      showSortControls={true}
      showContactFrequency={true}
    />
  );
};

export default Patients;